import { cn } from "../../lib/utils"

// Small red dot that marks something still needing input — next to a tab
// label or a table-of-contents entry whose content is out of view. Same mark
// as the "Needs attention" heading on the Tasks page.
export default function AlertDot({ label = "Not filled", className }: { label?: string; className?: string }) {
  return (
    <span className={cn("inline-block size-1.5 shrink-0 rounded-full bg-destructive", className)} role="img" aria-label={label} />
  )
}
